// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfilePhoto--styles-module_container-28Utv","centered":"ProfilePhoto--styles-module_centered-d-DY_"};